import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d0fb042"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-product-card" }
const _hoisted_2 = { class: "product-image-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "cart-product-info" }
const _hoisted_5 = { class: "product-info" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"4px"} }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "price" }
const _hoisted_9 = { class: "cart-product-quantity-info" }
const _hoisted_10 = { class: "quantity-info" }
const _hoisted_11 = { class: "price-text-total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.product.getPhotoUrl())
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: $props.product.getPhotoUrl()!,
            alt: "Product image",
            class: "product-image"
          }, null, 8 /* PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString($props.product.name), 1 /* TEXT */),
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, "R$ " + _toDisplayString($setup.FormatUtils.formatPrice($props.product.b2b_price)), 1 /* TEXT */)
        ]),
        _createVNode($setup["ExpiresCard"], {
          "expires-at": $props.product.getNextExpiresAt()
        }, null, 8 /* PROPS */, ["expires-at"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode($setup["PlusMinus"], {
          amount: $props.quantity,
          packageAmount: $props.product.getUnitsPerPackage(),
          stockQuantity: $props.product.getAvailableStock(),
          onRemoveFromCart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove-from-cart', $event))),
          onSetAmount: _cache[1] || (_cache[1] = (amount, evt) => _ctx.$emit('set-amount', amount, evt)),
          onAddAmount: _cache[2] || (_cache[2] = (amount, evt) => _ctx.$emit('add-to-cart', amount, evt)),
          style: {
            width: 'fit-content',
          }
        }, null, 8 /* PROPS */, ["amount", "packageAmount", "stockQuantity"]),
        _createElementVNode("p", _hoisted_11, "R$ " + _toDisplayString($setup.FormatUtils.formatPrice($props.product.b2b_price * $props.quantity)), 1 /* TEXT */)
      ]),
      _createVNode($setup["FontAwesomeIcon"], {
        icon: $setup.Icons.imported.faTrash,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('remove-from-cart', $event))),
        class: "trash-btn"
      }, null, 8 /* PROPS */, ["icon"])
    ])
  ]))
}